
/*
  Animated Stories
*/
const initAnimatedStories = () => {
  const localStorageKeyMain = 'ecomify_animated_stories'
  const localStorageKeyTime = 'ecomify_animated_stories_time'

  document.querySelectorAll('.animated-stories-link').forEach(link => {
    let storiesRead = JSON.parse(localStorage.getItem(localStorageKeyMain)) || []

    if (new Date().getTime() > Number(localStorage.getItem(localStorageKeyTime)) + 8.64e+7) {
      storiesRead = []
    }

    const storyIsRead = storiesRead.some((elem) => elem === link.getAttribute('href'))

    if (storyIsRead) {
      link.classList.add('story-is-read')
    }

    link.addEventListener('click', (e) => {
      if (!storyIsRead) {
        storiesRead.push(link.getAttribute('href'))
      }

      localStorage.setItem(localStorageKeyMain, JSON.stringify(storiesRead))
      localStorage.setItem(localStorageKeyTime, new Date().getTime())
    })
  })

  const lazyVideosObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.play()
      }
    })
  }, { rootMargin: '0px 0px 300px 0px' })
  document.querySelectorAll('.animated-stories video[data-autoplay="true"]').forEach((el) => {
    lazyVideosObserver.observe(el)
  })
}
initAnimatedStories()